import { render, staticRenderFns } from "./ModalDataCirurgia.vue?vue&type=template&id=51925744&scoped=true"
import script from "./ModalDataCirurgia.vue?vue&type=script&lang=ts"
export * from "./ModalDataCirurgia.vue?vue&type=script&lang=ts"
import style0 from "./ModalDataCirurgia.vue?vue&type=style&index=0&id=51925744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51925744",
  null
  
)

export default component.exports